import PlanList from "./PlanList";
// import PlanCreate from "./PlanCreate";
// import PlanEdit from "./PlanEdit";
// import PlanShow from "./PlanShow";
import PlanIcon from "@mui/icons-material/AttachMoney";

const plans = {
  list: PlanList,
//   create: PlanCreate,
//   edit: PlanEdit,
//   show: PlanShow,
  icon: PlanIcon,
};

export default plans;
